const successMessages = {
    userCreatedSuccessfully: "User created successfully",
    success: "success",
    appraisalSent: "Appraisal certificate sent to your email address"

}
export default successMessages
